<div *ngIf="user">
  <h4><p class="text-center">Gebruiker {{user.name}}</p></h4>

  <div class="row ui-toolbar">
    <div class="col-md-6">
      <button type="button" class="btn btn-outline-danger" (click)="deleteUser()">
        Verwijderen
      </button>
    </div>
  </div>

  <div class="card">
    <div class="card-block">
      <pre *ngIf="error">{{error}}</pre>
      <div class="form-group row">
        <label class="col-form-label col-3">Naam</label>
        <div class="col-9"><input class="form-control" [(ngModel)]="user.name" type="text"></div>
      </div>

      <div class="form-group row">
        <label class="col-form-label col-3">Email</label>
        <div class="col-9"><input class="form-control" [(ngModel)]="user.email" type="text" disabled></div>
      </div>

      <div class="form-group row">
        <label class="col-form-label col-3">Rechten</label>
        <div class="col-9"><p-dropdown [options]="userRoles" [(ngModel)]="user.role"></p-dropdown></div>
      </div>

      <div class="form-group row">
        <label class="col-form-label col-3">Nieuw wachtwoord instellen</label>
        <div class="col-9">
          <div class="form-check disabled">
            <label class="form-check-label">
              <input class="form-check-input" type="checkbox" [checked]="setNewPassword" (change)="setNewPassword = !setNewPassword">
              vervangen
            </label>
          </div>
        </div>
      </div>

      <div *ngIf="setNewPassword" class="form-group row">
        <label class="col-form-label col-3">Nieuw wachtwoord</label>
        <div class="col-9"><input class="form-control" [(ngModel)]="newPassword" type="text"></div>
      </div>

      <div *ngIf="setNewPassword" class="form-group row">
        <label class="col-form-label col-3">Herhaling nieuw wachtwoord</label>
        <div class="col-9"><input class="form-control" [(ngModel)]="newPasswordRepeat" type="text"></div>
      </div>
    </div>
  </div>
</div>

<div class="row ui-toolbar">
  <div class="col-md-6">
    <button type="button" class="btn btn-primary" (click)="saveUser()">
      Opslaan
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
      Annuleren
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/admin/users/details/users.details.component.html